import CheckCircleBroken from "@/assets/icons/check-circle-broken.svg";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

export enum DeepFocusNavigationBarDirection {
    LEFT = "left",
    RIGHT = "right",
}

interface DeepFocusNavigationBarProps {
    displayedMailIndex: number;
    unprocessedMailCount: number;
    handleMailChange: (direction: DeepFocusNavigationBarDirection) => void;
    handleProcessingMail: () => void;
}

const navButtonClassName =
    "border border-white/20 bg-white/10 hover:bg-white/20";

const DeepFocusNavigationBar = ({
    displayedMailIndex,
    unprocessedMailCount,
    handleMailChange,
    handleProcessingMail,
}: DeepFocusNavigationBarProps) => (
    <div className="flex h-full w-full items-center justify-end">
        <div className="flex items-center justify-center gap-3 text-white">
            <Button
                className={navButtonClassName}
                onClick={handleProcessingMail}
                size="circle"
                variant="invisible"
            >
                <img alt="" className="h-4" src={CheckCircleBroken} />
            </Button>
            <Button
                className={navButtonClassName}
                onClick={() =>
                    handleMailChange(DeepFocusNavigationBarDirection.LEFT)
                }
                size="circle"
                variant="invisible"
            >
                <ChevronLeft />
            </Button>
            <p className="text-base font-medium text-white">
                {displayedMailIndex + 1} / {unprocessedMailCount}
            </p>
            <Button
                className={navButtonClassName}
                onClick={() =>
                    handleMailChange(DeepFocusNavigationBarDirection.RIGHT)
                }
                size="circle"
                variant="invisible"
            >
                <ChevronRight />
            </Button>
        </div>
    </div>
);

export default DeepFocusNavigationBar;
